// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/types';

export const getCSATSubmittedDate = (state: ReduxStateShared) => state.csat.lastSubmittedDate;
